import { ConfirmationModalComponent } from 'commons/components';
import { PocTypography } from 'commons/components/components-wrapper/poc-typography.component';
import { useTranslation } from 'core/i18n/i18n';
import { PopupProps } from 'react-popup-manager';
import { DELETE_MATERIAL_KEY } from './delete-material-confirmation.constants';

interface DeleteMaterialConfirmationProps extends PopupProps {
    materialName: string;
    onConfirm: () => Promise<unknown>;
}

export const DeleteMaterialConfirmationComponent: React.FC<DeleteMaterialConfirmationProps> = ({
    isOpen,
    onClose,
    materialName,
    onConfirm,
}) => {
    const { t } = useTranslation();

    return (
        <ConfirmationModalComponent
            isOpen={isOpen}
            onClose={onClose}
            title={t(DELETE_MATERIAL_KEY.confirmTitle)}
            buttonText={t(DELETE_MATERIAL_KEY.confirmButton)}
            actionOnClick={onConfirm}
        >
            <PocTypography>{t(DELETE_MATERIAL_KEY.confirmMessage, { name: materialName })}</PocTypography>
        </ConfirmationModalComponent>
    );
};
